module.exports = __webpack_public_path__ + "img/how.7125ca6c.jpg";